export default __webpack_public_path__ + "static/media/move.e26d185c.mp3";